import React, { useState, useEffect, useCallback } from 'react';
import { Input, FormGroup, Label, Row, Col, Alert } from 'reactstrap';
import Select from 'react-select';
import { AdminPreQualificationList } from '../models/preQualificationModel';

interface Props {
  pqs: AdminPreQualificationList[];
  onFilterChange: (filtered: AdminPreQualificationList[]) => void;
}

const PreQualificationListSearch = ({ pqs, onFilterChange }: Props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [noResults, setNoResults] = useState(false);

  const statusOptions = [
    { value: 'all', label: 'Todos' },
    { value: 'created', label: 'Creado' },
    { value: 'under_review', label: 'Revisión' },
    { value: 'active', label: 'Activa' },
    { value: 'disabled', label: 'Desactivada' },
    { value: 'closed', label: 'Cerrada' },
    { value: 'evaluated', label: 'Evaluada' },
  ];

  const applyFilters = (
    items: AdminPreQualificationList[],
    term: string,
    status: string | null,
  ) => {
    let filtered = [...items];

    if (term.trim()) {
      filtered = filtered.filter(
        (pq) =>
          pq.borrower.first_name.toLowerCase().includes(term.toLowerCase()) ||
          pq.borrower.last_name.toLowerCase().includes(term.toLowerCase()) ||
          pq.borrower.email.toLowerCase().includes(term.toLowerCase()) ||
          pq.borrower_project.property_info
            .toLowerCase()
            .includes(term.toLowerCase()),
      );
    }

    if (status && status !== 'all') {
      filtered = filtered.filter((pq) => pq.status === status);
    }

    setNoResults(filtered.length === 0);
    return filtered;
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTerm = e.target.value;
    setSearchTerm(newTerm);
    onFilterChange(applyFilters(pqs, newTerm, statusFilter));
  };

  const handleStatusChange = (selected: any) => {
    const newStatus = selected?.value || null;
    setStatusFilter(newStatus);
    onFilterChange(applyFilters(pqs, searchTerm, newStatus));
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter(null);
    onFilterChange(pqs); // Reset to original data
    setNoResults(false);
  };

  return (
    <>
      <Row className="mb-4">
        <Col md={6}>
          <FormGroup>
            <Label for="search">Buscar</Label>
            <Input
              id="search"
              type="text"
              placeholder="Buscar por nombre, email o propiedad..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="status">Estado</Label>
            <Select
              id="status"
              isClearable
              placeholder="Filtrar por estado"
              options={statusOptions}
              onChange={handleStatusChange}
              value={
                statusOptions.find((option) => option.value === statusFilter) ||
                null
              }
            />
          </FormGroup>
        </Col>
      </Row>

      {noResults && (searchTerm || statusFilter) && (
        <Alert color="warning" className="mt-3">
          <div className="d-flex justify-content-between align-items-center">
            <span>
              No se encontraron resultados para los filtros aplicados.
              {searchTerm && (
                <span className="ml-2">
                  Término de búsqueda: "{searchTerm}"
                </span>
              )}
              {statusFilter && statusFilter !== 'all' && (
                <span className="ml-2">
                  Estado: "
                  {
                    statusOptions.find((opt) => opt.value === statusFilter)
                      ?.label
                  }
                  "
                </span>
              )}
            </span>
            <button className="btn btn-link p-0" onClick={handleClearFilters}>
              Limpiar filtros
            </button>
          </div>
        </Alert>
      )}
    </>
  );
};

export default PreQualificationListSearch;
